"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isFocusPage, theme } = param;
    return {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: isFocusPage ? theme.spacing(4) : theme.spacing(6),
        flexWrap: 'wrap',
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(6)
        }
    };
});
